export function createPdfFile(blob, orderNumber) {
  var newBlob = new Blob([blob], { type: "application/pdf" });
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement("a");
  link.href = data;
  link.download = `PN-${"00" + orderNumber}.pdf`;
  link.click();
}

// PN - Broj naloga
// PN - 001
